import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { Provider } from 'react-redux';
import { LegacyUserActions } from 'vn-legacy-user';

import registerServiceWorker from './registerServiceWorker';
import store from './store';
import { INITIALIZE, initialize } from './ducks/ApplicationDucks';


function renderApp(initialData) {
  ReactDOM.render(
    <Provider store={store}>
      <App initialData={initialData} />
    </Provider>,
    document.getElementById('root')
  );
}

if (window.parent) {
  const message = LegacyUserActions.readyToReceiveData();
  window.parent.postMessage(message, '*');
}

const messageHandler = {
  [LegacyUserActions.INJECT_SESSIONS]: ({ payload }) => {
    renderApp(payload);
  },
  [INITIALIZE]: ({ settings }) => {
    if (settings) {
      store.dispatch(initialize(settings));
    }
  }
};

window.addEventListener('message', evt => {
  if (evt.type === 'message' && messageHandler[evt.data.type]) {
    messageHandler[evt.data.type](evt.data);
  }
});


// let mockData;

// mockData = {
//   vnSecret: '97826c5f02d840ce68929f982d6d88c9'
// };

// renderApp(mockData);


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js